<template>
    <div>
        <div>

            <div class="d-flex justify-content-between" v-if="is_anat_pat">
                <div>
                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="abrir_amostras()" data-toggle="tooltip" data-placement="top" title="Amostras / Etiquetas">
                        <i class="fa-solid fa-flask-vial"></i> 
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="abrir(atp)" data-toggle="tooltip" data-placement="top" title="Incluir Procedimento Complementar" v-if="false && !atp.st_regiao">
                        <i class="fa-solid fa-circle-plus"></i>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="gerar_etiquetas()" data-toggle="tooltip" data-placement="top" title="Gerar Etiquetas">
                        <i class="fa-solid fa-barcode"></i>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="ver_tempos()" v-if="atendimento" data-toggle="tooltip" data-placement="top" title="Rastreabilidade">
                        <i class="fa-solid fa-clock-rotate-left"></i>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="ver_resps()" v-if="atendimento" data-toggle="tooltip" data-placement="top" title="Responsáveis">
                        <i class="fa-solid fa-user-check"></i>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="abrir_doc_pre_atend()" v-if="atendimento" data-toggle="tooltip" data-placement="top" title="Documento de Pré-Atendimento">
                        <i class="fa-solid fa-clipboard-check"></i>
                    </button>

                    <template v-if="!atp.st_regiao">

                        <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="nova_requisicao()" title="Nova Requisicao" v-if="atp.anamnese && atp.anamnese.requisicao">
                            <i class="fa fa-heartbeat" aria-hidden="true"></i>
                        </button>

                        <button type="button" class="btn btn-outline-primary btn-sm mr-1" title="Nova Requisicao" v-else disabled>
                            <i class="fa fa-heartbeat" aria-hidden="true"></i>
                        </button>

                    </template>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="editar_classes()" data-toggle="tooltip" data-placement="top" title="Classificação">
                        <i class="fa-solid fa-list"></i>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="camera()" data-toggle="tooltip" data-placement="top" title="Abrir Camera (CONTROL+G)" v-shortkey="['ctrl', 'g']" @shortkey="camera()">
                        <i class="fa-solid fa-camera"></i>
                    </button>

                    <template v-if="atp && atp.laudo && atp.laudo.sinals">
                        <button type="button" class="btn btn-sm mr-1" 
                            v-for="(sinal, isx) in atp.laudo.sinals" :key="isx"
                            :class="( sinal.sinalizador ) ? 'btn-outline-' + sinal.sinalizador.st_cor : 'btn-outline-secondary'" 
                            @click="editar_sinalizador()" 
                            data-toggle="tooltip" 
                            data-placement="top" 
                            :title="( sinal.sinalizador ) ? sinal.sinalizador.search : 'Editar Sinalizador'">
                            <i :class="( sinal.sinalizador ) ? sinal.sinalizador.st_icon : 'fa-solid fa-ellipsis'"></i>
                        </button>
                    </template>

                    <button type="button" class="btn btn-sm mr-1" 
                        :class="( atendimento && atendimento.marcacao && atendimento.marcacao.sinalizador_atendimento ) ? 'btn-outline-' + atendimento.marcacao.sinalizador_atendimento.st_cor : 'btn-outline-secondary'" 
                        @click="editar_sinalizador()" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        :title="( atendimento && atendimento.marcacao && atendimento.marcacao.sinalizador_atendimento ) ? atendimento.marcacao.sinalizador_atendimento.search : 'Editar Sinalizador'">
                        <i :class="( atendimento && atendimento.marcacao && atendimento.marcacao.sinalizador_atendimento ) ? atendimento.marcacao.sinalizador_atendimento.st_icon : 'fa-solid fa-ellipsis'"></i>
                    </button>

                    <span class="badge ml-2" :class="'badge-' + cor_prazo(atp.laudo, atp.dt_entrega)" v-if="atp.dt_entrega" data-toggle="tooltip" data-placement="top" :title="'Prazo de Entrega: ' + $util.getFormatDate(atp.dt_entrega)">
                        P: {{ $util.getFormatDate(atp.dt_entrega) }}
                    </span>

                    <i class="fa-solid fa-circle-exclamation text-danger ml-3" v-if="atp.fl_urgente" data-toggle="tooltip" data-placement="top" title="Urgente"></i>
                    
                    <span class="ml-2" v-if="atp.amostra && atp.amostra.st_amostra_material">
                        <small class="text-muted mr-1">
                            {{ atp.amostra.st_amostra_material }}
                        </small>

                        <template v-if="atp.amostra.js_classes && atp.amostra.js_classes.length > 0">
                            <span v-for="(classe, icx) in atp.amostra.js_classes" :key="icx" class="badge badge-secondary ml-1">
                                {{ classe }}
                            </span>
                        </template>
                    </span>

                    <span class="ml-2 mr-1" v-if="atp.st_regiao || ( atp.procedimento.js_complementos && atp.procedimento.js_complementos.length > 0 )">
                        <a href="#" @click.prevent="editar_regiao(atp)" class="small card-link">
                            {{ atp.st_regiao ? atp.st_regiao : 'Não Definido' }}
                        </a>
                    </span>
                </div>

                <div>
                    <span class="badge badge-dark ml-2" v-if="atendimento.apoiado" data-toggle="tooltip" data-placement="top" :title="atendimento.apoiado.st_nome + ( atendimento.apoiado_origem ? ' / ' + atendimento.apoiado_origem.st_nome : '' )">
                        {{ atendimento.apoiado.st_sigla ? atendimento.apoiado.st_sigla : atendimento.apoiado.st_nome }}
                    </span>

                    <span class="ml-2" v-if="atp.grupo_etq_amostras">
                        <span v-for="(grupo, igx) in atp.grupo_etq_amostras" :key="igx" class="badge badge-primary ml-1" :title="grupo.tipo_etiqueta.st_titulo">
                            <i :class="grupo.tipo_etiqueta.st_icon" v-if="grupo.tipo_etiqueta.st_icon"></i>
                            <span v-else-if="grupo.tipo_etiqueta.st_sigla">
                                {{ grupo.tipo_etiqueta.st_sigla }}
                            </span>
                            <span v-else>
                                {{ grupo.tipo_etiqueta.st_titulo }}
                            </span>

                            <span class="ml-2">
                                {{ grupo.qt_itens }}
                            </span>
                        </span>
                    </span>
                </div>
            </div>

            <template v-if="atp.laudo && atp.laudo.js_classes && atp.laudo.js_classes.length > 0">
                <span v-for="(classe, icx) in atp.laudo.js_classes" :key="icx" class="badge badge-success mr-1">
                    {{ classe }}
                </span>
            </template>

            <div class="mt-3"></div>

            <div class="form-row" v-if="atendimento && ( atendimento.cid || atendimento.medico_solicitante )">
                <div class="col col-12 col-md-6" v-if="atendimento && atendimento.medico_solicitante">
                    <div class="alert alert-secondary small py-1 px-2" v-if="atendimento && atendimento.medico_solicitante">
                        Solicitante: {{ atendimento.medico_solicitante.search }}
                    </div>
                </div>

                <div class="col col-12 col-md-6" v-if="atendimento && atendimento.cid">
                    <div class="alert alert-secondary small py-1 px-2" v-if="atendimento && atendimento.cid">
                        CID: {{ atendimento.cid.st_codigo }} - {{ atendimento.cid.st_cid }}
                    </div>
                </div>
            </div>

            <div class="alert alert-danger d-flex justify-content-between" v-if="atp.atendimento_procedimento_guia && atp.atendimento_procedimento_guia.guia && ( atp.atendimento_procedimento_guia.guia.ch_status == 'PR' || atp.atendimento_procedimento_guia.guia.ch_status == 'PE' )">
                <div>
                    <i class="fa fa-exclamation-triangle text-danger mr-2" aria-hidden="true"></i>
                    Guia com status <strong>PENDENTE</strong>
                </div>
                <div>{{ atp.atendimento_procedimento_guia.guia.ch_status }}</div>
            </div>

            <table class="table table-sm table-hover bg-white small" v-if="atp.laudo && atp.laudo.rastro && atp.laudo.rastro.length">
                <thead>
                    <tr>
                        <th></th>
                        <th>Rastreabilidade</th>
                        <th>Data/Hora</th>
                        <th>Usuário</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(rastro, ir) in atp.laudo.rastro">
                        <tr v-if="true" :key="'r' + ir">
                            <td>
                                <a href="#" @click.prevent="rastro.doc.fl_ativo = !rastro.doc.fl_ativo" v-if="rastro.id_documento_pre_atendimento && rastro.doc">
                                    <i class="fa-solid fa-clipboard-check"></i>
                                </a>
                            </td>
                            <td>
                                <span class="badge" :class="'badge-' + rastro.status_laudo.st_color">
                                    {{ rastro.status_laudo ? rastro.status_laudo.search : '?' }}
                                </span>
                            </td>
                            <td>
                                {{ $util.getFormatDate(rastro.created_at) }}
                                {{ rastro.created_at.substr(11,8) }}

                                <a href="#" @click.prevent="undo_rastro(atp, rastro)" class="ml-2" v-if="is_anat_pat && ir && ( ir == ( atp.laudo.rastro.length - 1 ) ) && ( rastro.id_usuario == $store.state.user.id_usuario ) && no_prazo_undo(rastro)" title="Desfazer">
                                    <i class="fa fa-undo" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td>{{ rastro.usuario ? rastro.usuario.st_login : '' }}</td>
                            <td>{{ rastro.st_obs }}</td>
                        </tr>
                        <tr v-if="rastro.doc && !rastro.doc.fl_ativo" :key="'rd' + ir">
                            <td colspan="5">
                                <div class="px-3">
                                    <formulario 
                                        :value="rastro.doc.js_conteudo"
                                        :compact="rastro.doc.fl_compact"
                                        mode="view" />
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <template v-if="is_anat_pat">

                <table class="table table-sm table-hover small bg-white" v-if="atp.lista_proc_complementar && atp.lista_proc_complementar.length > 0">
                    <thead>
                        <tr>
                            <th>Complemento</th>
                            <th>Código</th>
                            <th>Informação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(proc, ipx) in atp.lista_proc_complementar" :key="ipx">
                            <td>{{ proc.procedimento.search }}</td>
                            <td>{{ proc.st_codigo }} {{ proc.st_titulo }}</td>
                            <td>
                                <a href="#" @click.prevent="editar_regiao (proc)" class="card-link">
                                    {{ proc.complemento }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Requisição -->

                <template v-if="atp.anamnese && atp.anamnese.requisicao && atendimento">

                    <order-set-view
                        callback_compartilhar2="compartilhar_order_set"
                        :dados="atp.anamnese.requisicao"
                        type="requisicao"
                        @editar="abrir_req('requisicao', $event, atp.anamnese.requisicao.fl_cirurgia)"
                        @imprimir="imprimir_requisicao"
                        @refresh="$emit('refresh')"
                        @assinar="assinar"
                        :atendimento="atendimento"
                        :pep="true"
                        :block_ass="false"
                    />

                    <!-- Requisição -->
                    <order-set
                        title="Requisição de Procedimentos"
                        v-model="requisicao"
                        service="procedimentos.index"
                        name="requisicao"
                        ref="requisicao"
                        :cirurgia="false"
                        :id_anamnese="atp.anamnese.id_anamnese"
                        :id_paciente="atendimento.id_paciente"
                        :atendimento="atendimento"
                        @refresh="imprimir_requisicao"
                        :cassetes="lista_cassetes"
                    ></order-set>

                </template>

                <!-- Fim Requisição -->

                <multiselect
                    class="mt-3"
                    v-if="1==0 && atp.laudo"
                    v-model="atp.laudo.js_classes"
                    :options="options_classes"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTagProc"
                    placeholder="Selecione uma classificação..."
                    selectLabel="Pressione [ENTER] para selecionar"
                    deselectLabel="Pressione [ENTER] para remover"
                    tagPlaceholder="Pressione [ENTER] para incluir"
                    selectedLabel="Selecionado">
                    <template slot="noOptions">
                        Nenhuma classificação selecionada.
                    </template>
                </multiselect>

            </template>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="procCompModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Procedimento Complementar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-sub-title title="Procedimento"></az-sub-title>
                        <div class="list-group mb-3" v-if="dados && dados.procs">
                            <button type="button" class="list-group-item list-group-item-action" :class="proc_selec && ( proc.id_procedimento == proc_selec.id_procedimento ) ? 'active' : ''" v-for="(proc, ipx) in dados.procs" :key="ipx" @click="selecionar_procedimento(proc)">
                                {{ proc.search }}
                            </button>
                        </div>

                        <div v-if="proc_selec && proc_selec.js_complementos && proc_selec.js_complementos.length > 0" class="mb-3">

                            <div v-if="dados && dados.paineis && dados.paineis.length">
                                <button type="button" class="btn btn-sm btn-outline-primary" v-for="(painel, index) in dados.paineis" :key="index" @click="selecionar_painel(painel)">
                                    {{ painel.search }}
                                </button>
                            </div>

                            <multiselect
                                class="mt-3"
                                v-model="complementos"
                                :options="lista_complementos_simples"
                                :multiple="true"
                                :taggable="false"
                                @tag="addTagComp"
                                placeholder="Selecione..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhum item selecionado.
                                </template>
                            </multiselect>

                            <div class="mt-3" v-if="fila_laudo && fila_laudo.lista_status && fila_laudo.lista_status.length">
                                <div class="d-flex flex-column" v-if="status_selec">
                                    <button type="button" class="btn btn-sm btn-dark" @click="status_selec = null">
                                        {{ status_selec.st_acao ? status_selec.st_acao : status_selec.search }}
                                    </button>
                                </div>

                                <template v-else>
                                    <button type="button" class="btn btn-sm mr-1 mb-1" :class="'btn-' + (status.st_color.startsWith('outline-') ? status.st_color : 'outline-' + status.st_color)" 
                                        v-for="(status, isx) in fila_laudo.lista_status" :key="isx" @click="status_selec = status">
                                        {{ status.st_acao ? status.st_acao : status.search }}
                                    </button>
                                </template>
                            </div>

                        </div>

                        <template v-if="proc_selec && dados && dados.amostras && dados.amostras.length"> <!-- && !( atp_edit_ap && atp_edit_ap.amostra_atendimento_procedimentos && atp_edit_ap.amostra_atendimento_procedimentos.length ) -->
                            <az-sub-title title="Amostra"></az-sub-title>
                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <div class="list-group" v-if="dados && dados.amostras && dados.amostras.length">
                                        <template v-for="(amostra, ipx) in dados.amostras">
                                            <button 
                                                type="button" 
                                                class="list-group-item list-group-item-action py-2 small" 
                                                :class="amostra.selec ? 'active' : ''"
                                                v-if="( !amostra.id_amostra_repeticao && amostra.id_tipo_etiqueta_amostra )" 
                                                :key="ipx" 
                                                @click="select_amostra_comp(amostra)">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        {{ amostra.search }}
                                                        <span class="small text-muted ml-2" v-if="amostra.st_destino">
                                                            {{ amostra.st_destino }}
                                                        </span>
                                                    </div>
                                                    <div v-if="false && amostra.material" class="small text-muted">
                                                        {{ amostra.material.search }}
                                                    </div>
                                                </div>
                                                <div v-if="amostra.destino_amostra && amostra.destino_amostra.length" class="mt-2">
                                                    <ul class="mb-0">
                                                        <li v-for="(dest, dix) in amostra.destino_amostra" :key="dix">
                                                            {{ dest.search }} 
                                                            <span v-if="dest.st_destino" class="ml-2 small text-muted">
                                                                {{ dest.st_destino }}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </button>
                                        </template>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-8">
                                    <table class="table table-sm table-hover small">
                                        <thead>
                                            <tr>
                                                <th>Selecionado</th>
                                                <th>Anticorpos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(cassete_sel, iqx) in dados.amostras">
                                                <tr v-if="cassete_sel.selec" :key="iqx">
                                                    <td width="50%" class="text-nowrap">
                                                        <a href="#" @click.prevent="cassete_sel.selec = false" class="card-link mr-2">
                                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                        </a>
                                                        {{ cassete_sel.st_titulo }}
                                                    </td>
                                                    <td width="50%">
                                                        <span class="badge badge-light mr-1" v-for="(classe, icx) in cassete_sel.js_classes" :key="icx">
                                                            <a href="#" @click.prevent="remover_item_lista(cassete_sel.js_classes, icx)" class="card-link mr-1">
                                                                <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                            </a>
                                                            {{ classe }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>

                        <br><br><br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit v-if="proc_selec && ( amo_selec || amostras_selecionadas.length )" @click="atualizar()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="editarProcCompModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Editar
                            <span class="badge badge-secondary ml-2" v-if="atp_edit_ap">{{ atp_edit_ap.id_atendimento_procedimento }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="atp_edit_ap">

                        <div class="alert alert-info">
                            {{ atp_edit_ap.procedimento.search }}
                        </div>

                        <div v-if="proc_selec && proc_selec.js_complementos && proc_selec.js_complementos.length > 0" class="mb-3">

                            <div v-if="dados && dados.paineis && dados.paineis.length">
                                <button type="button" class="btn btn-sm btn-outline-primary" v-for="(painel, index) in dados.paineis" :key="index" @click="selecionar_painel(painel)">
                                    {{ painel.search }}
                                </button>
                            </div>

                            <div class="text-right small" v-if="!adicao">
                                <a href="#" @click.prevent="adicao = !adicao; complementos = []" class="card-link">
                                    Adição
                                </a>
                            </div>

                            <div v-else class="d-flex flex-column mt-1">
                                <span class="badge badge-dark">Adição</span>
                            </div>

                            <multiselect
                                class="mt-3"
                                v-model="complementos"
                                :options="lista_complementos_simples"
                                :multiple="true"
                                :taggable="false"
                                @tag="addTagComp"
                                placeholder="Selecione..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhum item selecionado.
                                </template>
                            </multiselect>

                            <div class="mt-3" v-if="fila_laudo && fila_laudo.lista_status && fila_laudo.lista_status.length">
                                <div class="d-flex flex-column" v-if="status_selec">
                                    <button type="button" class="btn btn-sm btn-dark" @click="status_selec = null">
                                        {{ status_selec.st_acao ? status_selec.st_acao : status_selec.search }}
                                    </button>
                                </div>

                                <template v-else>
                                    <button type="button" class="btn btn-sm mr-1 mb-1" :class="'btn-' + (status.st_color.startsWith('outline-') ? status.st_color : 'outline-' + status.st_color)" 
                                        v-for="(status, isx) in fila_laudo.lista_status" :key="isx" @click="status_selec = status">
                                        {{ status.st_acao ? status.st_acao : status.search }}
                                    </button>
                                </template>
                            </div>

                        </div>

                        <div v-if="1==0 && proc_selec.js_complementos && proc_selec.js_complementos.length > 0" class="mb-3">
                            <ul class="list-group mb-1">
                                <li class="list-group-item" v-for="(comp, icx) in complementos" :key="icx">
                                    <a href="#" @click.prevent="remover_complemento(icx)" class="mr-2">
                                        <i class="fa-solid fa-xmark text-danger"></i>
                                    </a>
                                    {{ comp }}
                                </li>
                            </ul>
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        icon="fa fa-plus"
                                        placeholder="Selecione..."
                                        type="select"
                                        :optionsList="lista_complementos"
                                        optionsData="id"
                                        v-model="novoComplemento"
                                        @input="selecionar_complemento" />
                                </div>
                            </div>
                        </div>

                        <template v-if="proc_selec && dados && dados.amostras && dados.amostras.length"> <!-- && !( atp_edit_ap && atp_edit_ap.amostra_atendimento_procedimentos && atp_edit_ap.amostra_atendimento_procedimentos.length ) -->
                            <az-sub-title title="Amostra"></az-sub-title>
                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <div class="list-group" v-if="dados && dados.amostras && dados.amostras.length">
                                        <template v-for="(amostra, ipx) in dados.amostras">
                                            <button 
                                                type="button" 
                                                class="list-group-item list-group-item-action py-2 small" 
                                                :class="( ( amostra.selec && !adicao ) || ( amostra.adicao && adicao ) ) ? 'active' : ''"
                                                v-if="( !amostra.id_amostra_repeticao && amostra.id_tipo_etiqueta_amostra )" 
                                                :key="ipx" 
                                                @click="select_amostra_comp(amostra)">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        {{ amostra.search }}
                                                        <span class="small text-muted ml-2" v-if="amostra.st_destino">
                                                            {{ amostra.st_destino }}
                                                        </span>
                                                    </div>
                                                    <div v-if="false && amostra.material" class="small text-muted">
                                                        {{ amostra.material.search }}
                                                    </div>
                                                </div>
                                                <div v-if="amostra.destino_amostra && amostra.destino_amostra.length" class="mt-2">
                                                    <ul class="mb-0">
                                                        <li v-for="(dest, dix) in amostra.destino_amostra" :key="dix">
                                                            {{ dest.search }} 
                                                            <span v-if="dest.st_destino" class="ml-2 small text-muted">
                                                                {{ dest.st_destino }}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </button>
                                        </template>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-8">
                                    <table class="table table-sm table-hover small">
                                        <thead>
                                            <tr>
                                                <th>Selecionado</th>
                                                <th>Anticorpos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(cassete_sel, iqx) in dados.amostras">
                                                <tr v-if="cassete_sel.selec" :key="iqx">
                                                    <td width="50%" class="text-nowrap">
                                                        <a href="#" @click.prevent="cassete_sel.selec = false" class="card-link mr-2">
                                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                        </a>
                                                        {{ cassete_sel.st_titulo }}
                                                    </td>
                                                    <td width="50%">
                                                        <span class="badge badge-light mr-1" v-for="(classe, icx) in cassete_sel.js_classes" :key="icx">
                                                            <a href="#" @click.prevent="remover_item_lista(cassete_sel.js_classes, icx)" class="card-link mr-1" v-if="!adicao">
                                                                <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                            </a>
                                                            {{ classe }}
                                                        </span>

                                                        <template v-if="adicao && cassete_sel.novos && cassete_sel.novos.length">
                                                            <span class="badge badge-secondary mr-1" v-for="(classe, icx) in cassete_sel.novos" :key="icx">
                                                                <a href="#" @click.prevent="remover_item_lista(cassete_sel.novos, icx)" class="card-link mr-1">
                                                                    <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                                </a>
                                                                {{ classe }}
                                                            </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>

                        <br><br><br><br><br><br><br><br><br><br>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit v-if="proc_selec && ( amo_selec || amostras_selecionadas.length )" @click="atualizar('editarProcCompModal')">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Editar Região -->
        <div class="modal fade" id="editarRegiaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Informação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <pre>{{ edicao_regiao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Classificação -->
        <div class="modal fade" id="editarClassificacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Classificação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_classes">
                        <multiselect
                            :options="options_classes"
                            v-model="edicao_classes.js_classes"
                            :multiple="true"
                            :taggable="true"
                            @tag="addTagProc"
                            placeholder="Selecione uma classificação..."
                            selectLabel="Pressione [ENTER] para selecionar"
                            deselectLabel="Pressione [ENTER] para remover"
                            tagPlaceholder="Pressione [ENTER] para incluir"
                            selectedLabel="Selecionado">
                            <template slot="noOptions">
                                Nenhuma classificação criada.
                            </template>
                        </multiselect>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_classes()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Rastreabilidade -->
        <tempos-marcacao ref="tempos" :only_rastro="true" />

        <!-- Gerar Etiquetas -->
        <gerar-etiqueta-a-p ref="etiquetas" @refresh="refresh()"/>

        <!-- Laudo Usuário Responsável -->
        <laudo-usuario ref="resp" @refresh="refresh()" />

        <!-- Documento de Pré-Atendimento -->
        <documento-pre-atendimento ref="doc_pre_atend" :pep="true" @refresh="refresh()" />

        <!-- Edição de Sinalizador -->
        <laudo-editar-sinalizador ref="editar_sinalizador" @refresh="refresh_sinalizador" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
// import * as moment from "moment";
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Multiselect from 'vue-multiselect';
import TemposMarcacao from '../../shared/TemposMarcacao.vue';
import GerarEtiquetaAP from '../laboratorio/GerarEtiquetaAP.vue'; 
import Formulario from '../consultorio/Formulario.vue';
import OrderSet from "../consultorio/OrderSet.vue";
import OrderSetView from "../consultorio/OrderSetView.vue";
import LaudoUsuario from './LaudoUsuario.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import LaudoEditarSinalizador from './LaudoEditarSinalizador.vue';

export default {
    data() {
        return { 
            dados: null, 
            proc_selec: null, 
            amo_selec: null, 
            novoComplemento: "", 
            complementos: [], 
            options_classes: [], 
            atp_edit_ap: null, 
            requisicao: { items: [] },
            edicao_regiao: null, 
            edicao_classes: null, 
            classes_base: null, 
            edicao_sinalizador: null, 
            status_selec: null, 
            validate: false, 
            adicao: false, 
        }
    },

    props: ['atp', 'laudo', 'atendimento', 'fila_laudo'],

    components: { 
        AzSubTitle,
        AzInput,
        AzSubmit, 
        Multiselect, 
        TemposMarcacao, 
        GerarEtiquetaAP, 
        Formulario, 
        OrderSet,
        OrderSetView,
        LaudoUsuario, 
        DocumentoPreAtendimento, 
        LaudoEditarSinalizador, 
    },

    computed: { 
        is_anat_pat: function () { 
            return ( this.atp && this.atp.procedimento && this.atp.procedimento.id_classe_procedimento == 20 ) ? true : false;
        },

        lista_complementos: function () { 
            if ( !this.proc_selec || !this.proc_selec.js_complementos || !this.proc_selec.js_complementos.length ) { 
                return []; 
            }

            let lista = this.proc_selec.js_complementos;

            return lista.sort().map(c => ({ id: c, search: c }));
        },

        lista_complementos_simples: function () { 
            if ( !this.proc_selec || !this.proc_selec.js_complementos || !this.proc_selec.js_complementos.length ) { 
                return []; 
            }

            let lista = this.proc_selec.js_complementos;

            return lista.sort();
        },

        amostras_selecionadas: function () { 
            if ( !this.dados || !this.dados.amostras ) { 
                return []; 
            }

            return this.dados.amostras.filter(a => a.fl_ativo);
        },

        lista_cassetes: function () { 
            if ( !this.atp || !this.atp.grupo_etq_amostras ) { 
                return []; 
            }

            let cassetes = this.atp.grupo_etq_amostras.find(grupo => grupo.amostras && grupo.amostras.length > 0);

            if ( cassetes ) { 
                return cassetes.amostras;
            }

            return []; 
        }
    },

    methods: { 
        editar_pre (doc_pre) { 
            this.$refs.doc_pre_atend.abrir(this.atendimento.marcacao, doc_pre);
        },

        refresh_sinalizador (res) { 

            if ( res && res.marcacao ) { 
                this.atendimento.marcacao.sinalizador_atendimento = res.marcacao.sinalizador_atendimento;
                this.atendimento.marcacao.id_sinalizador_atendimento = res.marcacao.id_sinalizador_atendimento;

                if ( res.sinals ) { 
                    this.atp.laudo.sinals = res.sinals;
                }
            }

            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });

        },

        undo_rastro (atp, rastro) { 
            if ( !confirm('Confirma desfazer o status "' + rastro.status_laudo.search + '"?') ) { 
                return; 
            }

            this.$util.atualizar (this, { 
                service: 'laudos',
                func: 'undo_rastro',
                dados: { 
                    id_laudo: atp.laudo.id_laudo,
                    id_laudo_status: rastro.id_laudo_status,
                },
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        no_prazo_undo (rastro) { 
            // let base = this.$util.hoje() + ' ' + moment().subtract(15, 'minutes').format("HH:mm:ss");
            let base = this.$util.hoje() + ' 00:00:00';

            if ( rastro.created_at && rastro.created_at > base ) { 
                return true; 
            }
            
            return false; 
        },

        select_amostra_comp (amostra) { 
            if ( this.adicao ) { 
                amostra.adicao = !amostra.adicao;     
                amostra.novos = amostra.adicao ? _.cloneDeep(this.complementos) : [];
            } else { 
                amostra.selec = !amostra.selec; 
                amostra.js_classes = _.cloneDeep(this.complementos);
            }
        },

        remover_item_lista (lista, idx) { 
            lista.splice(idx, 1);
        },

        laudo_status (status) { 
            console.log('Status:', status);
        }, 

        editar_sinalizador () { 
            this.$refs.editar_sinalizador.abrir(this.atp.laudo, this.atendimento.marcacao);
        },

        atualizar_classes () { 
            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'atualizar_classes',
                dados: { 
                    id_laudo: this.edicao_classes.id_laudo,
                    js_classes: this.edicao_classes.js_classes,
                },
                toast: true, 
                modal: 'editarClassificacaoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        editar_classes () { 
            this.edicao_classes = _.cloneDeep(this.atp.laudo);

            if ( this.classes_base === null ) { 
                this.$util.loadItem(this, { 
                    service: 'configuracoes',
                    func: 'get',
                    parms: { 
                        st_slug: 'laudo-classes', 
                    }
                })
                .then(res => { 
                    this.classes_base = res.st_valor ? _.uniq(res.st_valor.split(',').map(c => c.trim())).filter(c => c).sort() : [];
                    this.options_classes = ( this.atp.laudo.js_classes && this.atp.laudo.js_classes.length ) 
                        ? _.uniq(_.concat(this.classes_base, this.atp.laudo.js_classes)).sort()
                        : this.classes_base;
                });
            }

            $('#editarClassificacaoModal').modal('show');
        },

        selecionar_painel (painel) { 
            this.complementos = _.cloneDeep(painel.js_classes);
        },

        compartilhar_order_set () { 
            //
        },

        imprimir_requisicao (dados) { 
            this.$emit('refresh');

            if ( !dados )
                return;

            this.$util.print_preview('imprimir/requisicao/' + dados.id_requisicao, true, { modelo: dados.modelo, noass: 1 }, true);
        },

        assinar (order = null) { 
            if ( order ) { 
                this.$emit('assinar', order);
            }
        },

        abrir_req(ref, item = null, prescricao_cirurgia = false, tipo = null, info_solic = null) {

            let lista = null;

            if (item) {

                this[ref] = _.cloneDeep(item);

            } else {

                let peso = null;
                let altura = null;
                let creatinina = null;

                if ( this.atendimento && this.atendimento.marcacao && this.atendimento.marcacao.doc_pre_atends && ref == 'receita' && prescricao_cirurgia ) { 
                    let valores = this.atendimento.marcacao.doc_pre_atends.flatMap(item => item.js_conteudo ? item.js_conteudo : []);

                    if ( valores ) { 

                        valores = this.$util.valores(valores);

                        peso = _.get(valores.find(item => item.id == 'peso' && item.value), 'value');
                        altura = _.get(valores.find(item => item.id == 'altura' && item.value), 'value');
                        creatinina = _.get(valores.find(item => item.id == 'creatinina' && item.value), 'value');

                        peso = this.$util.tratar_valor(peso);
                        altura = this.$util.tratar_valor(altura);
                        creatinina = this.$util.tratar_valor(creatinina);

                    }
                }

                item = {
                    id_anamnese: this.value.id_anamnese,
                    fl_exibir_data: this.$util.getCookie(ref + '-exibir-data') == 'N' ? false : true,
                    dt_referencia: this.$util.hoje(),
                    st_tipo_receita: "",
                    items: [],
                    fl_prescricao: ( ref == 'requisicao' ? false : prescricao_cirurgia ),
                    fl_cirurgia: ( ref == 'receita' ? false : prescricao_cirurgia ),
                    fl_consulta: ( ref == 'requisicao' && tipo == 'C' ? true : false ),
                    id_cid: this.atendimento.id_cid,
                    cid: this.atendimento.cid,
                    id_cid_2: null,
                    cid2: null,
                    id_cid_3: null,
                    cid3: null,
                    materiais: [],
                    in_ciclos: null,
                    id_procedimento_protocolo: "", 
                    ver_peso: false, 
                    in_peso: peso, 
                    in_altura: altura, 
                    dc_cretinina: creatinina,
                    plano: null, 
                };

                if ( info_solic ) { 

                    if ( info_solic.id_cid_solic && info_solic.cid_solic ) { 
                        item.id_cid = info_solic.id_cid_solic;
                        item.cid = info_solic.cid_solic;
                    }

                    if ( info_solic.id_procedimento_solic && info_solic.procedimento_solic ) { 

                        let teste = this.value.requisicao.find(req => req.items && req.items.find(item => item.id_procedimento == info_solic.id_procedimento_solic));

                        if ( teste ) { 
                        return;
                        } 

                        lista = { 
                        items: [
                            { 
                            id_procedimento: info_solic.id_procedimento_solic,
                            item: info_solic.procedimento_solic
                            }
                        ]
                        };

                    }

                }

                this.requisicao = {
                    id_anamnese: this.value.id_anamnese,
                    fl_cirurgia: prescricao_cirurgia,
                    fl_consulta: item.fl_consulta,
                    id_plano: null, 
                    plano: null, 
                    items: [],
                    materiais: [],
                };

            }

            this.$refs[ref].abrir(item, lista);

        },

        abrir_doc_pre_atend () { 
            this.$refs.doc_pre_atend.abrir(this.atendimento.marcacao);
        }, 
        
        ver_resps () { 
            let laudo = _.cloneDeep(this.atp.laudo);
            let atp = _.cloneDeep(this.atp);

            atp.laudo = null; 
            atp.atendimento = this.atendimento; 

            laudo.atendimento_procedimento = atp; 

            this.$refs.resp.abrir(laudo);
        },

        refresh () { 
            this.$emit('refresh');
        },

        gerar_etiquetas () { 
            this.$refs.etiquetas.abrir(this.atp);
        },

        ver_tempos () { 
            console.log('atp2', this.atp);
            console.log('laudo2', this.laudo);

            let marcacao = _.cloneDeep(this.atendimento.marcacao);

            if ( marcacao ) { 
                marcacao.procedimento = this.atp.procedimento;
                marcacao.medico = this.atp.medico ? this.atp.medico : this.atendimento.medico;
                marcacao.timeline = null; 

                let atendimento = _.cloneDeep(this.atendimento);
                atendimento.marcacao = null;
                marcacao.atendimento = atendimento;
            }

            console.log('marcacao', marcacao);
            
            this.$refs.tempos.abrir(marcacao);
        },

        camera () { 
            this.$parent.enviar_arquivo({ camera: true }); 
        },  

        cor_prazo (laudo, prazo) { 
            if ( laudo && laudo.status_laudo && laudo.status_laudo.fl_pronto ) {
                return 'success';
            }

            if ( prazo ) { 
                if ( prazo ) { 

                    prazo = prazo.slice(0,10);
                    
                    if ( prazo < this.$util.hoje() ) { 
                        return 'danger';
                    } else if ( prazo == this.$util.hoje() ) { 
                        return 'warning';
                    } else { 
                        return 'primary';
                    }

                }
            } 

            return '';
        },

        addTagComp (newTag) {
            this.complementos.push(newTag);
        },
        
        addTagProc (newTag) {
            this.options_classes.push(newTag);

            if ( !this.edicao_classes.js_classes )
                this.edicao_classes.js_classes = [];

            this.edicao_classes.js_classes.push(newTag);
        },

        abrir_amostras () { 
            this.$parent.abrir_amostras();
        },
        remover_complemento (idx) { 
            this.complementos.splice(idx, 1);
            this.novoComplemento = ""; 
        },

        selecionar_complemento () { 
            if ( !this.novoComplemento ) { 
                return; 
            }

            let novo = this.novoComplemento.trim();

            this.novoComplemento = "";

            if ( this.complementos.includes(novo) ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Já selecionado: ' + novo,
                    life: 3000
                });
            } else { 
                this.complementos.push(novo);
            }

            /*
            this.$nextTick(() => { 
                this.novoComplemento = ""; 
            });
            */
        },

        selecionar_procedimento (proc) { 
            this.complementos = []; 
            this.novoComplemento = ""; 

            if ( this.proc_selec && ( this.proc_selec.id_procedimento == proc.id_procedimento ) ) { 
                this.proc_selec = null; 
            } else { 
                this.proc_selec = _.cloneDeep(proc); 
            }
        },

        selecionar_amostra (amo) { 
            if ( this.amo_selec && ( this.amo_selec.id_amostra == amo.id_amostra ) ) { 
                this.amo_selec = null; 
            } else { 
                this.amo_selec = _.cloneDeep(amo); 
            }
        },

        abrir (atp) { 
            this.proc_selec = null;
            this.amo_selec = null;
            this.status_selec = null;
            this.complementos = []; 
            this.novoComplemento = ""; 

            $('#procCompModal').modal('show');

            this.$util.load(this, { 
                service: 'laudos',
                func: 'ap_lista_comp',
                parms: { 
                    id_atendimento_procedimento: atp.id_atendimento_procedimento
                },
                loadTo: res => { 
                    this.dados = res; 
                }
            });
        },

        editar_regiao (atp) { 
            this.status_selec = null;
            this.atp_edit_ap = null; 

            this.$nextTick(() => { 
                
                this.atp_edit_ap = _.cloneDeep(atp);
    
                this.proc_selec = atp.procedimento;
                this.amo_selec = null;
                this.complementos = []; 
                this.novoComplemento = null; 
                this.adicao = false; 
    
                this.$nextTick(() => { 
                    this.novoComplemento = ""; 
                });
    
                $('#editarProcCompModal').modal('show');
    
                this.$util.load(this, { 
                    service: 'laudos',
                    func: 'ap_lista_comp',
                    parms: { 
                        id_atendimento_procedimento: atp.id_atendimento_procedimento, 
                        edicao: true, 
                    },
                    loadTo: res => { 

                        this.dados = res; 

                        if ( res && res.atp && res.atp.procedimento ) { 
                            this.proc_selec = res.atp.procedimento; 
                            this.complementos = res.complementos;
                            this.atp_edit_ap = res.atp;
                        }

                    }
                });            
               
            });
        },

        atualizar (modal = null) { 
            if ( this.proc_selec.js_complementos && this.proc_selec.js_complementos.length > 0 && this.complementos.length == 0 ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Selecione ao menos um anticorpo.',
                    life: 3000
                });
                return; 
            }

            if ( this.fila_laudo && this.fila_laudo.lista_status && this.fila_laudo.lista_status.length && !this.status_selec ) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Selecione o status.',
                    life: 3000
                });
                return; 
            }

            if ( this.proc_selec && this.dados && this.dados.amostras && this.dados.amostras.length ) { 
                let selecionadas = this.dados.amostras.filter(a => a.selec);

                if ( selecionadas.length == 0 ) { 
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'Atenção',
                        detail: 'Selecione ao menos um cassete.',
                        life: 3000
                    });
                    return; 
                }
            }

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'ap_incluir_comp',
                dados: { 
                    id_atendimento_procedimento: ( this.atp_edit_ap && this.atp_edit_ap.id_atendimento_procedimento ) 
                        ? this.atp_edit_ap.id_atendimento_procedimento 
                        : this.atp.id_atendimento_procedimento,
                    id_procedimento: this.proc_selec.id_procedimento,
                    id_amostra: this.amo_selec ? this.amo_selec.id_amostra : null,
                    id_amostras: this.dados.amostras.filter(a => !a.fl_ativo)
                        .map(a => a.id_amostra),
                    complementos: this.complementos, 
                    atualizacao: this.atp_edit_ap ? true : false,
                    amostras: this.dados.amostras, 
                    adicao: modal ? this.adicao : false, 
                },
                toast: true, 
                modal: modal ? modal : 'procCompModal',
                callback: () => { 
                    this.$emit('refresh'); 

                    if ( this.status_selec ) { 
                        this.$emit('status', this.status_selec);
                    }
                }
            });
        },

        nova_requisicao (item = null) { 

            let lista = null;

            if (item) {

                this.requisicao = _.cloneDeep(item);

            } else {

                let peso = null;
                let altura = null;
                let creatinina = null;

                item = {
                    id_anamnese: this.atp.anamnese.id_anamnese,
                    fl_exibir_data: this.$util.getCookie('requisicao-exibir-data') == 'N' ? false : true,
                    dt_referencia: this.$util.hoje(),
                    st_tipo_receita: "",
                    items: [],
                    fl_prescricao: false,
                    fl_cirurgia: false,
                    fl_consulta: false,
                    id_cid: this.atendimento.id_cid,
                    cid: this.atendimento.cid,
                    id_cid_2: null,
                    cid2: null,
                    id_cid_3: null,
                    cid3: null,
                    materiais: [],
                    in_ciclos: null,
                    id_procedimento_protocolo: "", 
                    ver_peso: false, 
                    in_peso: peso, 
                    in_altura: altura, 
                    dc_cretinina: creatinina,
                    plano: null, 
                };

                this.requisicao = item; 
            }

            this.$refs['requisicao'].abrir(item, lista);

        }

    }

}
</script>
